import { API_URL } from "../../../Config/api";
import React, { useState, useEffect } from "react";
import { Col, Divider, Table, Button, Space, Tag } from "antd";
import axios from "axios";
import dayjs from "dayjs";

export default function QuotasTab(props) {
  let userDrawer = props.user;

  const session_storage = JSON.parse(localStorage.getItem("session_data"));
  const [quotas, setQuotas] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setQuotas([]);
    fetchQuotas();
  }, [userDrawer]);

  const fetchQuotas = async () => {
    if (!userDrawer?.id) {
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(
        `${API_URL}/get-quotas-user/${userDrawer.id}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + session_storage.token,
          },
        }
      );

      const quotasOrdenadas = (response.data.quotas || []).sort(
        (a, b) => b.ano - a.ano
      );
      setQuotas(quotasOrdenadas);
    } catch (error) {
      console.log("error buscar quotas", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Tipo",
      dataIndex: "tipo",
    },
    {
      title: "Ano",
      dataIndex: "ano",
    },
    {
      title: "Valor",
      dataIndex: "valor",
      render: (valor) => (Number(valor) ? `${valor} €` : "N/A"),
    },
    {
      title: "Estado",
      dataIndex: "status",
      render: (status) =>
        status == "pago" ? (
          <Tag color="green">Pago</Tag>
        ) : (
          <Tag color="red">Não pago</Tag>
        ),
    },
    {
      title: "Data de pagamento",
      dataIndex: "payment_valid_date",
      render: (value) => {
        if (!value) return "-";
        const date = dayjs(value);
        const hasTime = value.includes("T") || value.includes(" ");
        return hasTime
          ? date.format("DD-MM-YYYY HH[h]mm[m]")
          : date.format("DD-MM-YYYY");
      },
    },
    {
      title: "Documentos",
      key: "documentos",
      render: (_, quota) => (
        <Space>
          {quota?.payment_file_receipt && (
            <Button
              href={`https://api.spap.pt/recibos/${quota.payment_file_receipt}`}
              download
            >
              Fatura
            </Button>
          )}
          {quota?.invoice_id &&
            quota?.payment_file_receipt == null &&
            quota.invoice_id.length > 4 && (
              <Button
                href={`${API_URL}/invoice/${quota.invoice_id}/download`}
                download
              >
                Fatura
              </Button>
            )}
          {quota?.payment_file_credit && (
            <Button
              target="_blank"
              href={`https://api.spap.pt/notaCredito/${quota.payment_file_credit}`}
            >
              Nota de crédito
            </Button>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Col
      style={{ padding: "30px", borderRadius: "16px", background: "#D6D7E2" }}
    >
      <h5 style={{ marginBottom: "10px", fontSize: "18px" }}>Quotas</h5>
      <p>Histórico de quotas associadas a este sócio.</p>
      <Divider></Divider>
      <Table
        rowKey="id"
        dataSource={quotas}
        columns={columns}
        loading={loading}
        pagination={{ pageSize: 10 }}
      />
    </Col>
  );
}
